import React, { Component } from "react";
import { Form, Icon, Input, Button, Row, Col, Card } from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { doAuth, authLocalJWT } from "../../store/actions/auth";
import AlertMessage from "../../components/Alert/Alert";
import logo from "../../assets/images/logo-min.png";
import _ from "lodash";
import "./login.css";

const FormItem = Form.Item;

class LoginPage extends Component {
  constructor() {
    super();
    this.state = {
      email: "",
      password: "",
      loginInProgress: false,
      message: "",
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
      } else {
        this.setState({
          message: "Email atau Password wajib diisi",
        });
      }
    });
  };

  componentDidMount() {
    let storage = localStorage.getItem("userDetail");
    if (storage) {
      try {
        let userDetail = JSON.parse(storage);
        if (userDetail) {
          if (!userDetail.token) {
            throw new Error("Invalid local data format");
          } else {
            this.props.authLocalJWT(userDetail);
          }
        }
      } catch (err) {
        localStorage.clear();
      }
    } else {
      console.log("tidak ada user detail di localStorage");
    }
  }

  componentDidUpdate(prevProps) {
    const { Auth } = this.props;
    if (prevProps.Auth.isAuthenticated !== Auth.isAuthenticated) {
      if (Auth.user) {
        if (
          [
            "APPRAISAL_ADMIN",
            "SUPER_ADMIN",
            "BUYER",
            "ACQUISITOR",
            "PRICE_NEGOTIATOR",
            "FINANCE_ADMIN",
            "DOCUMENT_ADMIN",
            "GP_ADMIN",
            "ALI",
            "BOH",
            "PRICING",
            "TNT",
            "DISPATCHER",
            "DATA_ADMIN",
            "DIRECTORS_USER",
            "SALES_USER",
            "GENERAL_MANAGER",
            "FINANCE",
          ].includes(Auth.user.role)
        ) {
          localStorage.setItem("userDetail", JSON.stringify(Auth));
          this.redirectUrl(Auth.user.role);
        } else {
          this.setState({
            message: "User not authorized",
          });
        }
      }
    }
    if (!prevProps.Auth.error && Auth.error) {
      this.setState({
        message: "Email atau Password Salah",
      });
    }
  }

  async redirectUrl(role) {
    const { location } = this.props;
    let pathname = _.get(location, "state.from.pathname");
    let url = pathname
      ? pathname.includes("home/e-approval/selling-system/detail") ||
        pathname.includes("home/e-approval/selling-system/boh/detail") ||
        pathname.includes("home/e-approval/selling-system/gm/detail") ||
        pathname.includes("home/e-approval/selling-system/admin/detail")
        ? pathname
        : null
      : null;
    await localStorage.removeItem("EApprovalPage");

    switch (role) {
      case "SUPER_ADMIN":
      case "GP_ADMIN":
      case "FINANCE":
        if (url)
          this.props.history.push({
            pathname: `/home/e-approval/selling-system/admin/detail/${
              url.split("detail/")[1]
            }`,
            state: { id: url.split("detail/")[1] },
          });
        else this.props.history.push("/home");
        break;
      case "APPRAISAL_ADMIN":
      case "ALI":
      case "DISPATCHER":
        this.props.history.push("/home");
        break;
      case "BUYER":
        this.props.history.push("/home/appraisal");
        break;
      case "ACQUISITOR":
        this.props.history.push("/home/appraisal");
        break;
      case "PRICE_NEGOTIATOR":
      case "DATA_ADMIN":
        this.props.history.push("/home/appraisal");
        break;
      case "DOCUMENT_ADMIN":
        this.props.history.push("/home/internal-bidding/document-approval");
        break;
      case "FINANCE_ADMIN":
        this.props.history.push("/home/internal-bidding/finance");
        break;
      case "PRICING":
        this.props.history.push("/home/price-list/jakarta");
        break;
      case "BOH":
        if (url)
          this.props.history.push({
            pathname: `/home/e-approval/selling-system/boh/detail/${
              url.split("detail/")[1]
            }`,
            state: { id: url.split("detail/")[1] },
          });
        else this.props.history.push("/home/appraisal");
        break;
      case "TNT":
        this.props.history.push("/home/appraisal");
        break;
      case "SALES_USER":
      case "FINANCE":
        if (url)
          this.props.history.push({
            pathname: `/home/e-approval/selling-system/detail/${
              url.split("detail/")[1]
            }`,
            state: { id: url.split("detail/")[1] },
          });
        else this.props.history.push("/home/e-approval/selling-system");
        break;
      case "GENERAL_MANAGER":
        if (url)
          this.props.history.push({
            pathname: `/home/e-approval/selling-system/gm/detail/${
              url.split("detail/")[1]
            }`,
            state: { id: url.split("detail/")[1] },
          });
        else this.props.history.push("/home/e-approval/selling-system");
        break;
      default:
        this.props.history.push("/home");
    }
  }

  onChangeInput = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
      message: "",
    });
  };

  onLogin = (e) => {
    e.preventDefault();
    let payload = {
      email: this.state.email,
      password: this.state.password,
    };
    this.props.doAuth(payload);
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { message } = this.state;

    return (
      <div>
        <Row type="flex" justify="space-around">
          <Col lg={{ span: 6 }} sm={{ span: 10 }}>
            <AlertMessage message={message} />
            <Card
              style={{
                marginTop: 100,
                borderRadius: 10,
                boxShadow: "2px 4px 66px -5px rgba(214,207,214,1)",
              }}>
              <div style={{ textAlign: "center" }}>
                <img
                  src={logo}
                  alt="logo_img"
                  style={{ width: 200, margin: "0px auto" }}
                />
              </div>
              <Form onSubmit={this.onLogin} className="login-form">
                <FormItem>
                  {getFieldDecorator("email", {
                    rules: [
                      {
                        type: "email",
                        message: "The input is not valid E-mail!",
                      },
                      {
                        required: true,
                        message: "Please input your E-mail!",
                      },
                    ],
                  })(
                    <Input
                      prefix={
                        <Icon
                          type="user"
                          style={{ color: "rgba(0,0,0,.25)" }}
                        />
                      }
                      onChange={this.onChangeInput}
                      name="email"
                      placeholder="Email"
                    />
                  )}
                </FormItem>
                <FormItem>
                  {getFieldDecorator("password", {
                    rules: [
                      {
                        required: true,
                        message: "Please input your Password!",
                      },
                    ],
                  })(
                    <Input
                      prefix={
                        <Icon
                          type="lock"
                          style={{ color: "rgba(0,0,0,.25)" }}
                        />
                      }
                      onChange={this.onChangeInput}
                      name="password"
                      type="password"
                      placeholder="Password"
                    />
                  )}
                </FormItem>
                <FormItem>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="login-form-button">
                    Log in
                  </Button>
                </FormItem>
              </Form>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const WrappedLoginPage = Form.create()(LoginPage);

const mapStateToProps = (state) => {
  return {
    Auth: state.Auth,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ doAuth, authLocalJWT }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(WrappedLoginPage);



// WEBPACK FOOTER //
// src/containers/Login/Login.js